export const AdminOnlyNotice: React.FC = () => (
  <p className="mb-2 text-sm text-muted-foreground">Only organization admins can edit this.</p>
)
